import { render, staticRenderFns } from "./AudienceSummaryRow.vue?vue&type=template&id=cdc71c54&scoped=true&"
import script from "./AudienceSummaryRow.vue?vue&type=script&lang=js&"
export * from "./AudienceSummaryRow.vue?vue&type=script&lang=js&"
import style0 from "./AudienceSummaryRow.vue?vue&type=style&index=0&id=cdc71c54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc71c54",
  null
  
)

export default component.exports